import { Dispatch } from 'redux';
import { CheckAdminClient } from '../Check/api';
import { AnalyticsActionTypes, MeasurementFilter } from '../../constants/Analytics';
import { downloadCsvFile } from '../../utils/download';

export const setFilter = (filter: MeasurementFilter) => ({
  type: AnalyticsActionTypes.SET_FILTER,
  filter,
});

export const getFilters = () => async (dispatch: Dispatch) => {
  dispatch({ type: AnalyticsActionTypes.START_FILTERS });
  try {
    const client = await CheckAdminClient.ClientFactory();
    const filters = await client.getAnalyticsFilters();
    dispatch({ type: AnalyticsActionTypes.FINISH_FILTERS, filters });
  } catch (error) {
    dispatch({ type: AnalyticsActionTypes.API_ERROR, error });
  }
};

export const searchMeasurements =
  (filter: MeasurementFilter, page = 1, perPage = 50) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: AnalyticsActionTypes.START_SEARCH });
    try {
      const client = await CheckAdminClient.ClientFactory();
      const res = await client.searchAnalyticsMeasurements(filter, page, perPage);
      dispatch({
        type: AnalyticsActionTypes.FINISH_SEARCH,
        payload: { items: res.Items, count: res.count, page: res.page, perPage: res.per_page },
      });
    } catch (error) {
      dispatch({ type: AnalyticsActionTypes.API_ERROR, error });
    }
  };

export const aggregateMeasurements =
  (filter: MeasurementFilter, bins: number[], groupBy: string[], dedupe: 'latest' | 'all' = 'latest') =>
  async (dispatch: Dispatch) => {
    dispatch({ type: AnalyticsActionTypes.START_AGGREGATE });
    try {
      const client = await CheckAdminClient.ClientFactory();
      const rows = await client.aggregateAnalyticsMeasurements(filter, bins, groupBy, dedupe);
      dispatch({ type: AnalyticsActionTypes.FINISH_AGGREGATE, payload: { rows, bins, groupBy, dedupe } });
    } catch (error) {
      dispatch({ type: AnalyticsActionTypes.API_ERROR, error });
    }
  };

// CSV は format=csv でサーバから本文を受け取り blob 保存。一覧は表示中ページ・per_page 上限500件単位。
export const downloadMeasurementsCsv = async (
  filter: MeasurementFilter,
  page = 1,
  perPage = 500,
  sort = '-started_at',
) => {
  const client = await CheckAdminClient.ClientFactory();
  const csv = await client.searchAnalyticsMeasurementsCsv(filter, page, perPage, sort);
  downloadCsvFile(`analytics_${filter.check_type}_measurements.csv`, csv);
};

export const downloadAggregateCsv = async (
  filter: MeasurementFilter,
  bins: number[],
  groupBy: string[],
  dedupe: 'latest' | 'all' = 'latest',
) => {
  const client = await CheckAdminClient.ClientFactory();
  const csv = await client.aggregateAnalyticsMeasurementsCsv(filter, bins, groupBy, dedupe);
  downloadCsvFile(`analytics_${filter.check_type}_distribution.csv`, csv);
};
